import { render, staticRenderFns } from "./azienda-salvioni.vue?vue&type=template&id=07f3f23e&scoped=true"
import script from "./azienda-salvioni.vue?vue&type=script&lang=js"
export * from "./azienda-salvioni.vue?vue&type=script&lang=js"
import style0 from "./azienda-salvioni.vue?vue&type=style&index=0&id=07f3f23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f3f23e",
  null
  
)

export default component.exports